export default __webpack_public_path__ + "static/media/free_trial.f4e02779.svg";